<template>
  <MainCard id="library-card">
    <template v-slot:body>
      <library-table-free></library-table-free>
    </template>
  </MainCard>
</template>

<script>
import MainCard from '../components/MainCard.vue'
import LibraryTableFree from './LibraryTableFree.vue'

export default {
  name: 'Tabs',
  components: {
    // LibraryTable,
    // LibrarySetting,
    LibraryTableFree,
    MainCard,
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    reRenderComponent(index) {
      if (index === 0) {
        this.componentKey += 1
      } else if (index === 1) {
        this.componentKey1 += 1
      } else {
        this.componentKe2 += 1
      }
    },
  },
}
</script>

<style>
</style>
